import React from 'react';
import SectionShell from '../SectionShell';
import useClickToArmVideo from '../../hooks/useClickToArmVideo';

/**
 * Schliff-VLOG slide — vlog #2, sits DIRECTLY BEFORE the Dual System
 * slide as a lead-in ("Vom Scan zum perfekten Schliff — so holen wir
 * das Maximum aus jedem Rohdiamanten").
 *
 * Presenter flow matches SectionBoxVideo:
 *  • 1st click → arm & start video
 *  • 2nd click → advance
 */
const VIDEO_SRC = '/videos/vlog-teil2-schliff.mp4';

export default function SectionSchliffVlog() {
  const { videoRef, stageRef } = useClickToArmVideo('schliff-vlog');

  return (
    <SectionShell
      id="schliff-vlog"
      className="relative overflow-hidden"
      fullBleed
      centerContent
    >
      <div
        ref={stageRef}
        className="zert-video-stage"
        data-testid="schliff-vlog-stage"
      >
        <div className="zert-video-frame">
          <video
            ref={videoRef}
            className="zert-video-el"
            playsInline
            controls
            preload="metadata"
            data-testid="schliff-vlog-video"
          >
            <source src={VIDEO_SRC} type="video/mp4" />
          </video>
        </div>
      </div>
    </SectionShell>
  );
}
